// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { TimelineDensity } from '@/constants/timeline-density';
import { useState } from 'react';

/**
 * A React hook that manages the zoom level of a timeline.
 *
 * @param defaultZoom - The default zoom level of the timeline.
 */
export function useTimelineZoom(defaultZoom: TimelineDensity) {
  const [zoom, setZoom] = useState(defaultZoom);

  const canZoomIn = () => {
    switch (zoom) {
      case 'day':
        return false;

      case 'week':
      case 'month':
        return true;
    }
  };

  const canZoomOut = () => {
    switch (zoom) {
      case 'day':
      case 'week':
        return true;

      case 'month':
        return false;
    }
  };

  const zoomIn = () => {
    setZoom((currentZoom) => {
      switch (currentZoom) {
        case 'day':
          return currentZoom;

        case 'week':
          return 'day';

        case 'month':
          return 'week';
      }
    });
  };

  const zoomOut = () => {
    setZoom((currentZoom) => {
      switch (currentZoom) {
        case 'day':
          return 'week';

        case 'week':
          return 'month';

        case 'month':
          return currentZoom;
      }
    });
  };

  return {
    zoom,
    zoomIn,
    zoomOut,
    setZoom,
    canZoomIn: canZoomIn(),
    canZoomOut: canZoomOut(),
  };
}
